import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle, Mountain } from "lucide-react";
import { useSite, resolveImg } from "../context/SiteContext";

export default function Footer() {
  const { brand } = useSite();
  return (
    <footer className="bg-foreground text-background mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            {brand.logo ? (
              <img src={resolveImg(brand.logo)} alt={brand.name} className="h-9 w-9 rounded-full object-cover" />
            ) : (
              <span className="h-9 w-9 grid place-items-center rounded-full bg-background text-foreground">
                <Mountain className="h-4 w-4" />
              </span>
            )}
            <div className="font-display text-xl">{brand.name}</div>
          </div>
          <p className="text-background/70 max-w-md leading-relaxed">
            A Shillong-based travel company crafting slow, considered journeys through Meghalaya, Assam and Arunachal — built around you.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={brand.instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 grid place-items-center rounded-full border border-background/30 hover:bg-background hover:text-foreground transition" data-testid="footer-instagram">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={`https://wa.me/91${brand.whatsapp}`} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="h-10 w-10 grid place-items-center rounded-full border border-background/30 hover:bg-background hover:text-foreground transition" data-testid="footer-whatsapp">
              <MessageCircle className="h-4 w-4" />
            </a>
            <a href={`mailto:${brand.email}`} aria-label="Email" className="h-10 w-10 grid place-items-center rounded-full border border-background/30 hover:bg-background hover:text-foreground transition" data-testid="footer-email">
              <Mail className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-background/50 mb-4">Quick Links</div>
          <ul className="space-y-3 text-background/80">
            <li><Link to="/journal" data-testid="footer-journal">Travel Journal</Link></li>
            <li><Link to="/packages" data-testid="footer-packages">Packages</Link></li>
            <li><Link to="/destinations" data-testid="footer-destinations">Destinations</Link></li>
            <li><Link to="/gallery" data-testid="footer-gallery">Gallery</Link></li>
            <li><Link to="/contact" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms">Terms</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-background/50 mb-4">Reach Us</div>
          <ul className="space-y-3 text-background/80">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0" /> +91 {brand.phone}</li>
            <li className="flex items-center gap-2"><MessageCircle className="h-4 w-4 shrink-0" /> +91 {brand.whatsapp}</li>
            <li className="flex items-center gap-2 break-all"><Mail className="h-4 w-4 shrink-0" /> {brand.email}</li>
            <li className="flex items-center gap-2"><Instagram className="h-4 w-4 shrink-0" /> @{brand.instagramHandle}</li>
            <li className="text-background/60 leading-relaxed pt-2">
              {brand.address}
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-background/50">
          <div>© {new Date().getFullYear()} {brand.name}. All rights reserved.</div>
          <div>Crafted with care in the hills of Shillong.</div>
        </div>
      </div>
    </footer>
  );
}
